import View from './View.js';
import previewView from './previewView.js';
import icons from 'url:../../img/icons.svg';

class BookmarksView extends View{

  _parentElement = document.querySelector('.bookmarks__list');
  _errorMessage = 'No bookmarks yet. Find a nice recipe and bookmark it :)';
  _message = '';

  addHandlerRender(handler) {
    window.addEventListener('load', handler);
    this._updateIcon();
  }

  _updateIcon() {
    document.querySelector('.nav__btn--bookmarks use').setAttribute('href', `${icons}#icon-bookmark`);
    const initialIcon = this._parentElement.querySelector('.message use');
    if (initialIcon) initialIcon.setAttribute('href', `${icons}#icon-smile`);
  }

  _generateMarkup() {
    return this._data.map(bookmark => previewView.render(bookmark, false)).join('');
    
  }
}

export default new BookmarksView();